import styled from 'styled-components';
import { Greyscale } from 'themes/rebrand/colours';

export const StyledTravelSummary = styled.div`
  flex-basis: 100%;
  margin-bottom: 8px;
  padding: ${({ bgColor }) => (bgColor ? '8px' : '0')};
  background-color: ${({ bgColor }) => bgColor || 'transparent'};
  color: ${({ fontColor, bgColor }) => (fontColor ? String(fontColor) : bgColor ? String(Greyscale.White) : 'inherit')};

  p {
    margin: 8px 0;
    color: ${({ fontColor, bgColor }) => (fontColor ? String(fontColor) : bgColor ? String(Greyscale.White) : 'inherit')};
  }

  span {
    color: ${({ fontColor, bgColor }) => (fontColor ? String(fontColor) : bgColor ? String(Greyscale.White) : 'inherit')};
  }

  svg {
    color: ${({ fontColor, bgColor }) => (fontColor ? String(fontColor) : bgColor ? String(Greyscale.White) : 'inherit')};
    stroke: ${({ fontColor, bgColor }) => (fontColor ? String(fontColor) : bgColor ? String(Greyscale.White) : 'currentColor')};
  }

  .travel-date {
    font-weight: bold;
  }
`;
